import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_3 = { class: "min-w-0 truncate text-catering-ink-900" }
const _hoisted_4 = {
  key: 0,
  class: "text-catering-ink-400"
}
const _hoisted_5 = { class: "flex shrink-0 items-center gap-2" }
const _hoisted_6 = { class: "tabular-nums text-catering-ink-700" }
const _hoisted_7 = {
  key: 0,
  class: "mt-1 text-[11px] text-catering-ink-500"
}


export default {
  __name: 'BotFeeConfig',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Your fees", -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.fees || [], (f, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "flex items-center justify-between gap-2 py-1.5"
        }, [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(f.label) + " ", 1),
            (f.custom_name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "· \"" + _toDisplayString(f.custom_name) + "\"", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(f.rate), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["rounded px-1.5 py-0.5 text-[11px] font-medium", 
              f.who_pays === 'customer'
                ? 'bg-catering-herb-100 text-catering-herb-600'
                : 'bg-catering-cream-300 text-catering-ink-600'
            ])
            }, _toDisplayString(f.who_pays), 3)
          ])
        ]))
      }), 128))
    ]),
    (__props.block.note)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.block.note), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}